var KMVP = KMVP || {}; // make sure KMVP is available

KMVP.myaccount = {
    bindOnChangeSubmit: function () {
        $(".js-on-change-submit").on("change", function () {
            $(this).closest('form').submit();
        })
    },
    bindSortLink: function () {
        $('.js-sort').on('click', function (e) {
            e.preventDefault();

            var sort = $(this).data("sort");
            var form = $(this).closest('form');

            form.find('input[name="sort"]').val(sort);
            form.submit();
        });
    },
    bindPageLink: function () {
        $('.js-orders-search-form').on('click', '.pagination a', function (e) {
            e.preventDefault();

            var href = $(this).attr("href");

            var page = href.substring(href.lastIndexOf('=') + 1);
            var form = $(e.delegateTarget);

            form.find('input[name="page"]').val(page);
            form.submit();
        });
    },
    bindDelayedOrdersLink: function () {
        $('.healdine-delayed-orders').on('click', function (e) {
            e.preventDefault();

            document.location.href = $(".js-orders-search-form").attr("action") + "?frontendStatus=DELAYED"
        });
    },
    storeOriginalFormValues: function () {
        $('.js-orders-search-form').find(':input').each(function () {
            var $this = $(this);
            $this.data('original-value', $this.val());
        });
    },
    /**
     * Resets the order history form input[name="page"] to 0, if any other input than input[name="page"] changed.
     * in other words: forget requested page nr and reset to 0, when search conditions change
     */
    bindOrderPageResetOnHistoryFormSubmit: function () {
        $('.js-orders-search-form').on('submit', function () {

            var form = $(this);
            var pageInput = form.find('input[name="page"]');

            if (pageInput.val() === "0") {
                return;
            }

            var valueChanged = false;
            form.find(':input').each(function () {
                if (!valueChanged) {
                    var input = $(this);
                    if (input.attr('name') !== 'page') {
                        valueChanged = input.data('original-value') !== input.val();
                    }
                }
            });

            if (valueChanged) {
                pageInput.val(0);
            }
        });
    },
    bindChangeDefaultB2BUnit: function() {
        $('.js-changeDefaultB2BUnit').on('click', function() {
            KMVP.regionalassortment.handleSessionAddressChangeClick($('.js-session-address-change')[0], false, true);
        });
    },
    bindMyAccountContent: function () {
        KMVP.myaccount.bindOnChangeSubmit();
        KMVP.myaccount.bindSortLink();
        KMVP.myaccount.bindPageLink();
        KMVP.myaccount.storeOriginalFormValues();
        KMVP.myaccount.bindOrderPageResetOnHistoryFormSubmit();
        KMVP.myaccount.bindDelayedOrdersLink();
        KMVP.myaccount.bindChangeDefaultB2BUnit();
    }
};

$(document).ready(function () {
    KMVP.myaccount.bindMyAccountContent();
});